<script setup lang="ts">
import SectionSidebar from '@/components/SectionSidebar.vue'
import type { SidebarMenuItem } from '@/components/SectionSidebar.vue'
import SouscriptionWidget from '@/components/SouscriptionWidget.vue'

const menuItems: SidebarMenuItem[] = [
  {
    to: '/front/ma-carte',
    icon: '/public/icons/icon-carte.svg',
    label: 'Ma carte',
    exact: true,
    initialSidebarOpen: true
  },
  {
    to: '/front/ma-carte/transactions',
    icon: '/public/icons/icon-transaction.svg',
    label: 'Transactions',
    initialSidebarOpen: true
  },
  {
    to: '/front/ma-carte/repartition',
    icon: '/public/icons/icon-souscription.svg',
    label: 'Répartition',
    initialSidebarOpen: true
  },
  {
    to: '/front/ma-carte/parametres',
    icon: '/public/icons/icon-verrouillage.svg',
    label: 'Paramètres',
    initialSidebarOpen: true
  }
]
</script>

<template>
  <SectionSidebar :menu-items="menuItems">
    <template #widget>
      <SouscriptionWidget />
    </template>
  </SectionSidebar>

  <section class="app-section">
    <div class="page-space-50" />
    <router-view />
  </section>
</template>
